import { makeStyles } from '@material-ui/core';

export const getProposalEditorGroupOfSettingsStyles = makeStyles((theme) => ({
  title: {
    marginTop: theme.spacing(1),
  },
}));
